// src/features/tab/tabSlice.js
import { createSlice } from "@reduxjs/toolkit";

const tabSlice = createSlice({
  name: "tab",
  initialState: {
    activeTab: "StampDuty", // default
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setActiveTab } = tabSlice.actions;
export const selectActiveTab = (state) => state.tab.activeTab;
export default tabSlice.reducer;
